import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import styled from 'styled-components';
import FigCaption from '../common/FigCaption';
import Translatable from '../common/Translatable';

import Heading from '../heading/Heading';
import Icon from '../Icon';
import Picture from '../image/CloudFrontPicture';
import Divider from '../styles/HorizontalDivider';

const SewpatSizeHelp = () => {
    const createData = (size, height, bust, waist, hip) => (
        {
            id: size,
            size,
            height,
            bust,
            waist,
            hip,
        }
    );

    const data = [
        createData(34, 168, 79, 64, 89),
        createData(36, 168, 83, 67, 93),
        createData(38, 168, 87, 71, 97),
        createData(40, 168, 91, 75, 101),
        createData(42, 168, 95, 79, 105),
        createData(44, 168, 99, 83, 109),
        createData(46, 168, 103, 87, 113),
        createData(48, 168, 109, 93, 119),
        createData(50, 168, 115, 99, 125),
        createData(52, 168, 121, 105, 131)];

    const StyledCollapsableContainer = styled.div`
        width: 94%;
        margin: 0 auto;

        & .schnoffle-collapsable-expanded h3 {
          padding: 0;
          margin-left: 40%;
          transform: translateX(-40%);
          border-bottom: 1px dashed;

        }

        & .schnoffle-expansion-dense {
          padding: 1em;
          display: block;
        }

        & .schnoffle-center {
          text-align: center;
        }
    `;

    const Figure = styled.figure`
        & img {
          max-height: 80vh;
          width: auto;
        }
    `;

    const ExpandMoreIcon = (
        <Icon
            name={'icon-keyboard_arrow_down'} width='1.5em'
            height='1.5em'
        />
    );

    return (
        <StyledCollapsableContainer>
            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={ExpandMoreIcon}
                    classes={{expanded: 'schnoffle-collapsable-expanded'}}
                >
                    <Heading
                        level={3} text={<Translatable
                        message='SEWPAT_SIZES_MEASURING_LABEL'
                    />}
                    />
                </ExpansionPanelSummary>
                <ExpansionPanelDetails
                    classes={{root: 'schnoffle-expansion-dense'}}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell padding='none'
                                           classes={{head: 'schnoffle-center'}}>
                                    <Translatable
                                        message='SEWPAT_FASHION_SIZE_LABEL'/>
                                </TableCell>
                                <TableCell classes={{head: 'schnoffle-center'}}
                                           padding='none'>
                                    <Translatable
                                        message='SEWPAT_BODYHEIGHT_LABEL'/> (cm)
                                </TableCell>
                                <TableCell classes={{head: 'schnoffle-center'}}
                                           padding='none'>
                                    <Translatable
                                        message='SEWPAT_BUST_LABEL'/> (cm)
                                </TableCell>
                                <TableCell classes={{head: 'schnoffle-center'}}
                                           padding='none'>
                                    <Translatable
                                        message='SEWPAT_WAIST_LABEL'/> (cm)
                                </TableCell>
                                <TableCell classes={{head: 'schnoffle-center'}}
                                           padding='none'>
                                    <Translatable
                                        message='SEWPAT_HIP_LABEL'/> (cm)
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map(n => (
                                <TableRow key={n.id}>
                                    <TableCell
                                        classes={{body: 'schnoffle-center'}}
                                        padding='none' component='th'
                                        scope='row'>
                                        {n.size}
                                    </TableCell>
                                    <TableCell
                                        classes={{body: 'schnoffle-center'}}
                                        padding='none'>{n.height}</TableCell>
                                    <TableCell
                                        classes={{body: 'schnoffle-center'}}
                                        padding='none'>{n.bust}</TableCell>
                                    <TableCell
                                        classes={{body: 'schnoffle-center'}}
                                        padding='none'>{n.waist}</TableCell>
                                    <TableCell
                                        classes={{body: 'schnoffle-center'}}
                                        padding='none'>{n.hip}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Divider/>
                    <div>
                        <Translatable message='SEWPAT_MEASURE_HELPTEXT'/>
                    </div>
                    <Divider/>
                    <Figure>
                        <Picture webp='vermessen-weiblich.webp'
                                 src='vermessen-weiblich.png' png schnoffle/>
                        <FigCaption><Translatable
                            message='SEWPAT_MEASURE_IMAGE_CAPTION'/></FigCaption>
                    </Figure>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </StyledCollapsableContainer>
    );
};

export default SewpatSizeHelp;



// WEBPACK FOOTER //
// ./src/components/sewpat/SewpatSizeHelp.js